<template>
  <div>
    <div class="title-bar el-row is-justify-space-between el-row--flex">
      <w-perf-analysis-time-info :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
      <div>
        <ul class="diff-legend-box">
          <li><span class="item added"></span>추가</li>
          <li><span class="item modified"></span>변경</li>
          <li><span class="item deleted"></span>삭제</li>
        </ul>
        <el-radio-group class="cmp-margin-left ordinary" v-model="diffFlag">
          <el-radio-button :label="true">변경내역만 보기</el-radio-button>
          <el-radio-button :label="false">전체 보기</el-radio-button>
          </el-radio-group>
      </div>
    </div>
    <hr class="mr-b20">
    <div v-loading="loading">
      <el-row class="title-bar">
        <el-col :span="12" class="vertical-center-box" style="height:31px;">
          <div class="title-h4 dot-title mr-r10">최근 컨피그</div><em>{{currentDate}}</em>
        </el-col>
        <el-col :span="12">
          <el-row type="flex" justify="space-between">
            <div class="vertical-center-box">
              <div class="title-h4 dot-title mr-r10">이전 컨피그</div><em>{{prevDate}}</em>
            </div>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <div v-html="configResultData"></div>
      </el-row>
    </div>
  </div>
</template>
<script>
import isNil from 'lodash/isNil';
import moment from 'moment';
import msgUtil from '@/utils/message';
import { isTrue } from '@/utils/boolean';
import { analysisTimeType } from '@/constants/performance';
import { EMPTY_TEXT } from '@/utils/string';
import netdeviceTableInfoAPI from '@/api/performance/netdevice/netdevice-table-info';
import analysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';

export default {
  name: 'WConfigChangeIngo',
  mixins: [analysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      analysisTimeType,
      loading: false,
      checkDatetime: null,
      diffFlag: false,
      currentDate: '',
      prevDate: '',
      compareConfigData: {
        diff: '',
        compare: '',
      },
    };
  },
  computed: {
    /**
     * 화면에 제공할 컨피그 내용
     * @author Ju
     * @return {[type]} [description]
     */
    configResultData() {
      let data;
      if (!this.diffFlag && !isNil(this.compareConfigData.compare)) {
        data = this.compareConfigData.compare;
      } else if (this.diffFlag && !isNil(this.compareConfigData.diff)) {
        data = this.compareConfigData.diff;
      } else {
        data = '변경된 내역이 없습니다.';
      }
      return data;
    },
  },
  methods: {
    /**
     * 컨피그 변경 이력을 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
      };
      if (this.timeType === this.analysisTimeType.HIST.value) {
        params.endDatetime = this.plotLineDatetime;
      } else {
        params.endDatetime = new Date().getTime();
      }

      this.loading = true;
      netdeviceTableInfoAPI.getChangedConfigInfo(params).then((response) => {
        if (response.data.success === true) {
          this.loading = false;
          this.setConfigData(response.data.data);
        } else {
          this.failToLoad();
        }
      }).catch(() => {
        this.failToLoad();
      }).finally(() => {
        this.loading = false;
      });
    },
    /**
     * 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '컨피그 변경 내용', false));
      this.setConfigData(null);
    },
    /**
     * 컨피그 데이터를 설정한다.
     * @author Ju
     * @param  {[type]} data [description]
     */
    setConfigData(data) {
      if (isNil(data)) {
        this.checkDatetime = null;
        this.currentDate = EMPTY_TEXT;
        this.prevDate = EMPTY_TEXT;
        this.compareConfigData = {
          diff: '',
          compare: '',
        };
        this.diffFlag = false;
      } else {
        this.compareConfigData = data.compareData;
        this.diffFlag = isTrue(data.compareData.diffFlag);
        // base
        if (isNil(data.baseCheckItemHist)) {
          this.currentDate = EMPTY_TEXT;
          this.checkDatetime = null;
        } else {
          this.currentDate = this.getDateString(data.baseCheckItemHist.checkDatetime);
          this.checkDatetime = data.baseCheckItemHist.checkDatetime;
        }
        // compare
        if (isNil(data.compareCheckItemHist)) {
          this.prevDate = EMPTY_TEXT;
        } else {
          this.prevDate = this.getDateString(data.compareCheckItemHist.checkDatetime);
        }
      }
    },
    /**
     * [날짜 포멧 설정]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getDateString(time) {
      return isNil(time) ? EMPTY_TEXT : moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netdevice/components/table/ConfigChangeInfo.vue